import { defineCustomElements as defineCustomComponentLibraryElements } from "@claromentis/design-system/dist/loader";
import "./src/styles/global.css";
require('./node_modules/dracula-prism/dist/css/dracula-prism.css');


export const onClientEntry = () => {
    if (typeof window !== 'undefined') {
        import('@ionic/core').then(() => {
            defineCustomComponentLibraryElements(window);
        }).then(() => {
            console.log("Component Library loaded successfully!");
        });
    }
};